import React from "react";
import {BrowserRouter, Switch, Route} from "react-router-dom";

import Home from "./Components/Home";
import Projects from "./Components/Projects";
import Experience from "./Components/Experience";
import Contact from "./Components/Contact";
import Readings from "./Components/Reads";
import Blog from "./Components/Blog";

const Routes = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path='/' component={Home}/>
                <Route exact path='/about' component={Home} />
                <Route exact path='/experience' component={Experience} />
                <Route exact path='/portfolio' component={Projects} />
                <Route exact path='/contact' component={Contact} />
                <Route exact path='/blogs' component={Readings} />
                <Route exact path='/blogs/:blog_name' component={Blog} />
            </Switch>
        </BrowserRouter>
    )
}

export default Routes;
